import { updateMediaItemF } from '../../../../backend/mediaItems/updateData'
import { globalOnDemandVars } from '../../../../helper/context'

export class InsertItemBase {
  constructor (type, title, content) {
    this.type = type
    this.title = title
    this.content = content
    this.globalId = null
  }

  setTitle (newTitle) {
    if (this.globalId) {
      updateMediaItemF(this.globalId, {
        title: newTitle
      }).then(() => {
        this.title = newTitle
      })
    } else {
      this.title = newTitle
    }
  }

  setContent (newContent) {
    this.content = newContent
  }

  setGlobalId (id) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'media setGlobalId',
        value: {
          globalId: id,
          this: this
        }
        // , important: true
      })
    }
    this.globalId = id
  }
}

export class Type1Item extends InsertItemBase {
  constructor (type, title, content, id, backId, globalId, inWaitingItemsForType1, inUsedItemsForType1) {
    super(type, title, content)
    this.backId = backId

    this.ThumbNailForceUpdateObject = {}

    this.setTitleForType1Item = null
    this.globalId = globalId

    if (id) {
      this.id = id
    } else {
      let nextId
      if (backId) {
        nextId = type + backId
      } else {
        const lastId = globalOnDemandVars.type1Count()
        nextId = lastId + 1
      }
      globalOnDemandVars.set_type1Count(nextId)
      this.id = nextId
    }

    this.inWaitingItemsForType1 = inWaitingItemsForType1
    this.inUsedItemsForType1 = inUsedItemsForType1
  }

  setContent (newContent) {
    this.content = newContent
    for (let i of Object.getOwnPropertyNames(this.ThumbNailForceUpdateObject)) {
      this.ThumbNailForceUpdateObject[i]()
    }
  }

  setThumbNailForceUpdate (id, f) {
    this.ThumbNailForceUpdateObject[id] = f
  }

  deleteThumbNailForceUpdate (id) {
    delete this.ThumbNailForceUpdateObject[id]
  }

  // type 1 에서의 이 아이템의 존재가 0번 아니면 1번이라는 가정에서임
  setSetTitleForType1Item (f) {
    this.setTitleForType1Item = f
  }
}

export class InsertItem extends InsertItemBase {
  constructor (type, title, content, count, globalId, id) {
    super(type, title, content)

    this.id = id || type + count
    this.globalId = globalId
  }
}
